module.exports = __webpack_public_path__ + "img/banner-background-mobile.a909290f.png";